import React, { Component, Suspense, lazy } from "react";
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import BridgeAuthRoute from "./bridgeAuthRoutes";
const MobileStatus = lazy(() => import("./Component/mobileStatus"));
const MobileStatusExplorer = lazy(() => import("./Component/mobileStatusExplorer"));
const Guide = lazy(() => import("./Component/guide"));
const SignUpsExplorer = lazy(() => import("./Component/signUpsExplorer"));
const MobileDeviceExplorer = lazy(() => import("./Component/mobileDeviceExplorer"));
const SignUpsWithRegionExplorer = lazy(() => import("./Component/signUpsWithRegionExplorer"));
const LabsSignUpsExplorer = lazy(() => import("./Component/labsSignUpsExplorer"));
const JobsExplorer = lazy(() => import("./Component/jobsExplorer"));
const PaidExplorer = lazy(() => import("./Component/paidExplorer"));
const UpgradesExplorer = lazy(() => import("./Component/upgradesExplorer"));
const ConversionsCombinedExplorer = lazy(() => import("./Component/conversionsCombinedExplorer"));
const TotalConversionsExplorer = lazy(() => import("./Component/totalConversionsExplorer"));
const TrialSignUpsWithRegionExplorer = lazy(() => import("./Component/trialSignupsWithRegionExplorer"));
const TrialSignUpsRepWithRegionExplorer = lazy(() => import("./Component/trialSignupsRepWithRegionExplorer"));
const TotalTrialsWithRegionExplorer = lazy(() => import("./Component/totalTrialsWithRegionExplorer"));
const TrialConversionsExplorer = lazy(() => import("./Component/trialConversionsExplorer"));
const TrialByRepExplorer = lazy(() => import("./Component/trialByRepExplorer"));
const TrialByPlanExplorer = lazy(() => import("./Component/trialByPlanExplorer"));
const TrialByAccountTypeExplorer = lazy(() => import("./Component/trialByAccountTypeExplorer"));
const TrialCancellationExplorer = lazy(() => import("./Component/trialCancelationExplorer"));
const TrialAccountsExplorer = lazy(() => import("./Component/trialAccountsExplorer"));
const ConversationWithDateChangeExplorer = lazy(() => import("./Component/conversationsExplorer-date_change"));
const MetricsRoutes = lazy(() => import("./metrics/MetricsRoutes"));

class Router extends Component{

 render(){
   // Each page loads on its own: the classic explorers bring antd and the data explorer, the
   // new dashboard brings ECharts, and neither should wait for the other.
   return <BrowserRouter>
   <Suspense fallback={null}>
   <Switch>
     <BridgeAuthRoute path="/metrics" Component={MetricsRoutes}/>
     <BridgeAuthRoute path="/guide" Component={Guide}/>
     <BridgeAuthRoute path="/signups-explorer" Component={SignUpsExplorer}/>
     <BridgeAuthRoute path="/signupsByRegion-explorer" Component={SignUpsWithRegionExplorer}/>
     <BridgeAuthRoute path="/trialSignupsWithRegion-explorer" Component={TrialSignUpsWithRegionExplorer}/>
     <BridgeAuthRoute path="/trialSignupsByRepWithRegion-explorer" Component={TrialSignUpsRepWithRegionExplorer}/>
     <BridgeAuthRoute path="/totalTrialsWithRegion-explorer" Component={TotalTrialsWithRegionExplorer}/>
     <BridgeAuthRoute path="/trialByPlan-explorer" Component={TrialByPlanExplorer}/>
     <BridgeAuthRoute path="/trialAccountType-explorer" Component={TrialByAccountTypeExplorer}/>
     <BridgeAuthRoute path="/trialByRep-explorer" Component={TrialByRepExplorer}/>
     <BridgeAuthRoute path="/signupsLabs-explorer" Component={LabsSignUpsExplorer}/>     
     <BridgeAuthRoute path="/paid-explorer" Component={PaidExplorer}/>
     <BridgeAuthRoute path="/jobs-explorer" Component={JobsExplorer}/>
     <BridgeAuthRoute path="/mobile-stats" Component={MobileStatus}/>
     <BridgeAuthRoute path="/mobile-stats-explorer"  Component={MobileStatusExplorer}/>
     <BridgeAuthRoute path="/mobile-device-explorer"  Component={MobileDeviceExplorer}/>
     <BridgeAuthRoute path="/upgrades-explorer"  Component={UpgradesExplorer}/>
     <BridgeAuthRoute path="/conversions-explorer"  Component={ConversationWithDateChangeExplorer}/>
     <BridgeAuthRoute path="/trialConversions-explorer"  Component={TrialConversionsExplorer}/>
     <BridgeAuthRoute path="/conversions-combined-explorer"  Component={ConversionsCombinedExplorer}/>
     <BridgeAuthRoute path="/total-conversions"  Component={TotalConversionsExplorer}/>
     <BridgeAuthRoute path="/trialCancellation-explorer" Component={TrialCancellationExplorer}/>
     <BridgeAuthRoute path="/trialAccounts-explorer" Component={TrialAccountsExplorer}/>
     <Route exact path="/">
       <Redirect to="/metrics" />
     </Route>

     <Route
          render={() => {
            window.location.href = "https://www.castingworkbook.com/404.html";
            return null;
          }}
        />
   </Switch>
   </Suspense>
   </BrowserRouter>
 }
}

export default Router;